import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { REST_API, CHAT_GPT, EXTERNAL_API, AIRTABLE } from 'drapcode-constant';
import * as actions from './redux/actions';
import ExternalApiList from './ExternalApiList';
import ParentDocCard from '../common/ParentDocCard';
import DocsLink from '../../common/custom/DocsLink';
import { parseExtractPluginCode } from '../../common/utils/plugin_utils';
import { checkToShowSaveBtn } from '../plugin/utils';
import VideoBox from '../../common/custom/VideoBox';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import CustomLoader from '../common/CustomLoader';
import { checkExternalAPIPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import ExternalApiHeaderNav from './ExternalApiHeaderNav';
export class DefaultPage extends Component {
  static propTypes = {
    externalapi: PropTypes.object.isRequired,
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = { activeTab: REST_API, headers: [], dataTypes: [] };

  componentDidMount = async () => {
    const { location, match, actions, home } = this.props;
    const { iPlugins } = home;
    const { projectId, version } = match.params;
    await actions.loadExternalDatabase({ projectId, version });
    await actions.loadCollections({ projectId, version });
    actions.getPermissionFlags({ projectId });
    let connectorType = REST_API;
    const externalData = this.props.externalapi.externalDatabase;
    let dataTypes = [];
    if (externalData) {
      dataTypes = [...new Set(externalData.map((item) => item.type))];
    }
    this.setState({ activeTab: connectorType, headers: dataTypes });
  };
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    const { home: nextHome, match } = nextProps;
    const { home } = this.props;
    const { iPlugins: nextIPlugins } = nextHome;
    if (!nextIPlugins || nextIPlugins.length === 0) {
      return true;
    }
    const { iPlugins } = home;
    const { activeTab: currActiveTab } = this.state;
    const { projectId } = match.params;
    let connectorType = '';
    if (!currActiveTab || !checkToShowSaveBtn(nextIPlugins, iPlugins)) {
      const headers = parseExtractPluginCode(nextIPlugins, 'EXTERNALAPI');
      connectorType = REST_API;
      this.setState({ activeTab: connectorType, headers });
    }
    return true;
  }

  toggle = (tab) => {
    this.setState({ activeTab: tab });
  };

  showSourceDocumentation = (activeTab) => {
    if (activeTab === AIRTABLE) {
      return (
        <>
          <h5>
            <b>About Airtable</b>
          </h5>
          <p>
            Many people opt for Airtable as it is a great way to store data using spreadsheets. The
            Airtable data source allows you to easily transfer all data from Airtable to your web
            app's database on DrapCode.
          </p>
          <br />
          <DocsLink link="https://academy.drapcode.com/docs/app-datasources/datasource-airtable" />
        </>
      );
    } else if (activeTab === REST_API) {
      return (
        <>
          <h5>
            <b>Data Search and CSV Download</b>
          </h5>
          <p>
            You can easily implement the functionality to search data that is coming from an
            external data source such as Supabase, Firebase, Airtable, Google Sheet etc, so that you
            can see and filter the results in the real-time.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-external-api/data-search-and-csv-download" />
          <br />
          <h5>
            <b>Display Browser Session Data in Data Table</b>
          </h5>
          <p>
            Bring external data via REST API and display it in a data table without saving it in a
            collection. You can display the data in tabular format by reading it directly from the
            browser session.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-external-api/display-browser-session-data-in-data-table" />
          <h5>
            <b>Pagination on Data Table Using External API</b>
          </h5>
          <p>
            You can easily fetch and display data on Data Table directly from any External API or
            REST API without storing the data in DrapCode's database.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-external-api/pagination-on-data-table-using-external-api" />
          <h5>
            <b>Update Data via Modal using External API</b>
          </h5>
          <p>
            You can easily add the functionality to create, edit, update and delete (CRUD
            operations) via Modal Popup on any data coming from 3rd party Data Source such as Google
            Sheet, Airtable, External APIs, Supabase, Firebase etc, without storing or persisting of
            data at the DrapCode database.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-external-api/update-data-via-modal-using-external-api-without-persisting-data" />
          <h5>
            <b>Create Data via Modal using External API</b>
          </h5>
          <p>
            You can easily add the functionality to create, edit, update and delete (CRUD
            operations) via Modal Popup on any data coming from 3rd party Data Source such as Google
            Sheet, Airtable, External APIs, Supabase, Firebase etc, without storing or persisting of
            data at the DrapCode database.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-external-api/update-data-via-modal-using-external-api-without-persisting-data" />
          <h5>
            <b>Delete Data via Modal using External API</b>
          </h5>
          <p>
            You can easily add the functionality to create, edit, update and delete (CRUD
            operations) via Modal Popup on any data coming from 3rd party Data Source such as Google
            Sheet, Airtable, External APIs, Supabase, Firebase etc, without storing or persisting of
            data at the DrapCode database
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-external-api/create-data-via-modal-using-external-api-without-persisting-data" />
          <h5>
            <b>External API Response in Data Table without Storing Data</b>
          </h5>
          <p>
            Allow you to fetch data from any data source such as Firebase, Supabase, Airtable,
            Google Sheet or any other datasource or REST API and showcase it in real time on Data
            Table without storing it in the collection.
          </p>
          <DocsLink link="https://academy.drapcode.com/docs/app-external-api/external-api-response-in-data-table-without-storing-data" />
          <br />
          <h5>
            <b>Videos</b>
          </h5>
          <VideoBox
            heading="External API Data Search and Download CSV without Storing Data View Video"
            videoLink="https://www.youtube.com/watch?v=SvJIy7fSVTA"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/External+API+Data+Search+and+Download+CSV+without+Storing+Data.jpg"
          />
          <br />
          <br />
          <VideoBox
            heading="Displaying Browser Session Records/Items in Data Table View Video"
            videoLink="https://www.youtube.com/watch?v=68cOdRrcyFY"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/Displaying+Browser+Session+Records%3AItems+in+Data+Table.jpg"
          />
          <br />
          <br />
          <VideoBox
            heading="External API Pagination on Data Table without Storing Data View Video"
            videoLink="https://www.youtube.com/watch?v=m6ldVNn5dCs"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/External+API+Pagination+on+Data+Table+without+Storing+Data.jpg"
          />
          <br />
          <br />
          <VideoBox
            heading="External API Create, Edit, Update & Delete via Modal Popup without Persisting Data View Video"
            videoLink="https://www.youtube.com/watch?v=DxLYoOETpyY"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/External+API+Pagination+on+Data+Table+without+Storing+Data.jpg"
          />
          <br />
          <br />
          <VideoBox
            heading="External API Response in Data Table without Storing Data View Video"
            videoLink="https://www.youtube.com/watch?v=zaxXEDufxIg"
            imgLink="https://drapcode-static.s3.amazonaws.com/docs-img/External+API+Response+in+Data+Table+without+Storing+Data.jpg"
          />
        </>
      );
    }

    return 'No Doc';
  };

  showTabBody = (header) => {
    const { activeTab } = this.state;
    const { match, externalapi } = this.props;
    const { projectId, version } = match.params;
    const { permissionFlags } = externalapi;
    let permissionsArray = [];
    if (permissionFlags && permissionFlags.length > 0) {
      permissionsArray = permissionFlags || [];
    }

    return (
      <div className={`tab-pane ${activeTab === header && 'active'}`} key={header}>
        <ExternalApiList
          version={version}
          projectId={projectId}
          activeTab={activeTab}
          flag={permissionsArray.includes(EXTERNAL_API)}
        />
        <ParentDocCard>{this.showSourceDocumentation(activeTab)}</ParentDocCard>
      </div>
    );
  };

  render() {
    const isAllowed = checkExternalAPIPermission();
    if (!isAllowed) {
      return <PermissionDenied message="External APIs" />;
    }
    const { match, externalapi, home } = this.props;
    const { iPlugins } = home;
    const chatGptPlugin = iPlugins && iPlugins.find((e) => e.code === CHAT_GPT);
    const { projectId, version } = match.params;
    const { loadExternalDatabasePending, loadCollectionsPending } = externalapi;

    const { headers, activeTab } = this.state;
    return (
      <CommonPageComponent>
        {loadExternalDatabasePending || loadCollectionsPending ? (
          <div className="text-center">
            <CustomLoader
              loading={loadExternalDatabasePending || loadCollectionsPending}
              size="20px"
              color="#303453"
            />
          </div>
        ) : (
          <>
            <ExternalApiHeaderNav
              version={version}
              activeTab={activeTab}
              projectId={projectId}
              headers={headers}
              enableChatGpt={chatGptPlugin ? true : false}
            />
            <div className="row mx-auto">
              <div className="tab-content w-100">
                {[REST_API, ...headers].map((header) => this.showTabBody(header))}
              </div>
            </div>
          </>
        )}
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalapi: state.externalapi,
    home: state.home,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
